var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-0 pl-3 texto-corrido regular"},[_vm._v(_vm._s(_vm.charsUsed))])}
var staticRenderFns = []

export { render, staticRenderFns }